import { ArrowDown, ArrowUp, Minus } from 'lucide-react';
import { cn } from '@/shared/lib/utils/classnames';
import type { StatBlock as StatBlockType } from '@/shared/types/blocks';

type StatBlockProps = Omit<StatBlockType, 'type' | 'id'>;

/**
 * StatBlock - 통계 수치 표시
 *
 * 숫자 데이터와 추세를 시각적으로 표시합니다.
 */
export function StatBlock({ label, value, icon, trend, unit }: StatBlockProps) {
  const TrendIcon = trend === 'up' ? ArrowUp : trend === 'down' ? ArrowDown : Minus;

  const trendColor = {
    up: 'text-green-500',
    down: 'text-red-500',
    neutral: 'text-muted-foreground',
  }[trend || 'neutral'];

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        {icon && <span className="text-base">{icon}</span>}
        <span>{label}</span>
      </div>
      <div className="flex items-baseline gap-2">
        <span className="text-2xl font-bold text-foreground">{value}</span>
        {unit && <span className="text-sm text-muted-foreground">{unit}</span>}
        {trend && (
          <TrendIcon className={cn('w-4 h-4', trendColor)} aria-label={`Trend: ${trend}`} />
        )}
      </div>
    </div>
  );
}
